<div class="_message-box-component" *ngIf="!closed">
	<div class="_content">
		<ng-content select="[content]"></ng-content>
	</div>
	<div (click)="close()" class="_close-button">
		<ion-icon src="./assets/icons/close-outline.svg"></ion-icon>
	</div>
</div>

